<template>
  <form
    ref="form"
    novalidate
    class="container px-0 d-flex flex-column justify-content-between needs-validation"
    @submit="submit"
  >
    <div class="flex-grow-1">
      <div class="row">
        <BootstrapFormControl
          v-model="modelName"
          name="Component Name"
          class="col"
          required
          :error="errorMessages.get('name')"
          :server-error="serverError"
        />
        <BootstrapFormControl
          v-model="modelEstimatedLabor"
          name="Estimated Time Labor"
          class="col"
          required
          :error="errorMessages.get('estimated_labor')"
          :server-error="serverError"
        />
        <BootstrapSelect
          v-model="modelCostPool"
          name="Cost Pool"
          class="col"
          :options="costPoolOptions"
          required
          :error="errorMessages.get('cost_pool_id')"
          :server-error="serverError"
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelDescription"
          name="Responsibility Description"
          class="col"
          required
          :error="errorMessages.get('description')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row mt-3">
        <div class="d-flex w-100">
          <BootstrapButton
            name="submit"
            class="me-2"
            type="submit"
            :disabled="loading"
            :loading="loading"
            @click.stop
          >
            Save
          </BootstrapButton>
          <BootstrapButton name="cancel" variant="secondary" @click="router.go(-1)">
            Cancel
          </BootstrapButton>
        </div>
      </div>
    </div>
  </form>
</template>
<script lang="ts" setup>
const props = defineProps<{
  costPool: string;
  costPoolOptions: string[];
  description: string;
  estimatedLabor: number;
  errorMessages: Map<any, any>;
  loading: boolean;
  name: string;
  serverError: boolean;
}>();

const emit = defineEmits<{
  'update:costPool': [value: string];
  'update:description': [value: string];
  'update:estimatedLabor': [value: number];
  'update:name': [value: string];
  submit: [form: globalThis.Ref<HTMLFormElement | null>];
}>();

const router = useRouter();

// Template ref
const form = ref<HTMLFormElement | null>(null);

// Models
const modelCostPool = computed({
  get: () => props.costPool,
  set: (value) => emit('update:costPool', value),
});
const modelDescription = computed({
  get: () => props.description,
  set: (value) => emit('update:description', value),
});
const modelEstimatedLabor = computed({
  get: () => String(props.estimatedLabor),
  set: (value) => emit('update:estimatedLabor', Number(value)),
});
const modelName = computed({
  get: () => props.name,
  set: (value) => emit('update:name', value),
});

// https://getbootstrap.com/docs/4.6/components/forms/?#how-it-works
const submit = async (event: Event) => {
  if (form.value?.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
    form.value.classList.add('was-validated');
  } else {
    event.preventDefault();
    emit('submit', form);
  }
};
</script>
